import { useEffect } from "react";
// react-router-dom components
import { Link } from "react-router-dom";
// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
// Authentication layout components
import IllustrationLayout from "../components";
import { useAuth0 } from "@auth0/auth0-react";

function Illustration() {
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {}, []);
  const currentUrl = window.location.protocol + "//" + window.location.host;
  const handleLogin = async () => {
    try {
      loginWithRedirect({
        screen_hint: "signup",
        prompt: "select_account",
        redirectUri: currentUrl + "/home"
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <IllustrationLayout title="Sign Up" description="Create an account right now">
      <div id="fff" style={{ display: "none" }}></div>

      <div id="fffd" style={{ position: "relative", top: "-50px" }}>
        <SoftBox mt={4} mb={1}>
          <SoftButton onClick={handleLogin} size="large" fullWidth>
            sign up
          </SoftButton>
        </SoftBox>
        <SoftBox mt={3} textAlign="center">
          <SoftTypography variant="button" color="text" fontWeight="regular">
            Don&apos;t have an account?{" "}
            <SoftTypography
              component={Link}
              to="/authentication/sign-in"
              variant="button"
              fontWeight="medium"
              textGradient
            >
              Sign in
            </SoftTypography>
          </SoftTypography>
        </SoftBox>
      </div>
    </IllustrationLayout>
  );
}

export default Illustration;
